import React, { createContext, useContext, ReactNode } from 'react';
import { useCesiumMap } from '../hooks/useCesiumMap';

type CesiumMapApi = ReturnType<typeof useCesiumMap>;

const CesiumContext = createContext<CesiumMapApi | null>(null);

export const CesiumProvider: React.FC<{ api: CesiumMapApi; children: ReactNode }> = ({ api, children }) => (
  <CesiumContext.Provider value={api}>{children}</CesiumContext.Provider>
);

export function useCesium(): CesiumMapApi {
  const ctx = useContext(CesiumContext);
  if (!ctx) throw new Error('useCesium must be used inside CesiumProvider');
  return ctx;
}
